module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/choose-sourcedout/we-got-you-4482e51ebcfd9fd5b717f22e123a8dfb.png";